import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { InputFileModule } from '../input-file';
import { InputImgFileComponent } from './input-img-file.component';

@NgModule({
    imports: [TwcModule, FormsModule, CommonModule, TranslateModule, InputFileModule],
    declarations: [InputImgFileComponent],
    exports: [InputImgFileComponent],
})
export class InputImgFileModule {}
